<template>
    <v-row no-gutters>
        <v-col cols="auto">
            <!-- <v-select v-model="query.sort" :items="sorts" item-text="text" item-value="value" label="정렬" v-bind="attrs_input" @change="search" /> -->
        </v-col>
        <v-spacer />
        <v-col cols="auto">
            <v-btn-toggle v-model="query.state" multiple borderless class="v-sheet--outlined rounded-0" style="overflow: hidden" @change="search">
                <v-btn :to="$route.query.state ? { query: { ...$route.query, state: [] } } : { query: $route.query }" exact active-class="primary white--text" @click.prevent.stop.capture="((query.state = []) || true) && search()">전체</v-btn>
                <v-btn v-for="{ text, value } in states" :key="text" v-bind="{ value }" exact active-class="primary white--text">{{ text }}</v-btn>
            </v-btn-toggle>
        </v-col>
    </v-row>
</template>

<script>
import { APPLICATION_STATES, attrs_input } from "@/assets/variables";

const sorts = [
    { text: "생성일 ↓", value: "createdAt_desc" },
    { text: "생성일 ↑", value: "createdAt_asc" },
    { text: "접수시작일 ↓", value: "application.startsAt_desc" },
    { text: "접수시작일 ↑", value: "application.startsAt_asc" },
    { text: "접수종료일 ↓", value: "application.endsAt_desc" },
    { text: "접수종료일 ↑", value: "application.endsAt_asc" },
];
const states = Object.values(APPLICATION_STATES);

const initQuery = () => ({
    sort: sorts[0].value,
    state: [],
});

export default {
    props: {
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        query: initQuery(),

        sorts,
        states,
        attrs_input,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        $route() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.query = {
                sort: this.$route.query?.sort || sorts[0].value,
                state: [this.$route.query?.state || []].flat(),
            };
        },
        search() {
            let { ...query } = this.query;

            if (!query.sort || query.sort == sorts[0].value) delete query.sort;
            if (!query.state) delete query.state;

            delete query.page;

            this.$router.push({ query });
        },
    },
};
</script>

<style></style>
